{
  "dss": {
    "footer": {
      "legalEntity": "Parque Ind. FINSA, Nave 30, 72710 Cuautlancingo, Puebla - Mexico"
    }
  }
}
